<template>
  <div class="pl-page">
    <pro-list-frame
      v-if="isDesktopListLayout"
      ref="plTable"
      :title="($t('main-group-list'))"
      icon="mdi-shape-outline"
      :total="totalItems"
      :rows="items.length"
      :search.sync="search"
      :columns="toggleableHeaders"
      :hidden="hiddenColumns"
      :selected-count="(selected || []).length"
      :loading="loading"
      :cell-sel="cellSel"
      :fixed="!mobileShow"
      :filterable="false"
      :create-label="(!mobileShow) ? $t('new-main-group') : ''"
      @refresh="getItems"
      @print="printStudio = true"
      @create="openDialog('add')"
      @toggle-column="toggleColumn"
      @show-all-columns="hiddenColumns = []"
      @cell-down="onCellDown"
      @cell-over="onCellOver"
      @clear-cells="clearCellSel"
      @clear-selection="selected = []"
    >
      <template #bulk>
      <button
        v-if="!mobileShow"
        type="button"
        class="pl-bulk__btn pl-bulk__btn--danger"
        @click="deletDialog = true"
      >
        <v-icon size="17">mdi-trash-can-outline</v-icon>
        {{ $t("remove") }}
      </button>
      </template>
      <v-data-table
        v-if="headers"
        ref="listTable"
        v-model="selected"
        v-column-resize="mainGroupColumnPlugins"
        v-column-drag="mainGroupColumnPlugins"
        v-column-pin="mainGroupColumnPlugins"
        :height="mobileShow ? 323 : plTableH"
        fixed-header
        :headers="tableHeaders"
        :items="items"
        :options.sync="options"
        :server-items-length="totalItems"
        :loading="false"
        :page.sync="page"
        :hide-default-header="isMobile || mobileShow"
        multi-sort
        :show-select="showSelect"
        item-key="id"
        :footer-props="plFooterProps"
      >
        <template v-if="isMobile || mobileShow" v-slot:item="{ item, index }">
          <tr :class="{ 'mobile-show': mobileShow }">
            <td class="px-0">
              <v-list-item
                class="data-table-list-items mobile-td-list-border-primary"
                dense
              >
                <v-list-item-icon>
                  <div class="d-flex">
                    <p class="mt-1">
                      {{ +index + +1 }}
                    </p>
                    <v-menu offset-y>
                      <template v-slot:activator="{ attrs, on }">
                        <v-btn color="primary" v-bind="attrs" icon v-on="on">
                          <v-icon medium> mdi-dots-vertical </v-icon>
                        </v-btn>
                      </template>
                      <v-list dense>
                        <v-list-item link @click="openDialog('edit', item, index)">
                          <v-list-item-icon>
                            <v-icon class="mt-2"> mdi-clipboard-edit </v-icon>
                          </v-list-item-icon>
                          <v-list-item-title v-text="$t('edit')" />
                        </v-list-item>
                        <v-list-item
                          v-show="removePermission(typeForm)"
                          link
                          @click="openDeleteDialog(item)"
                        >
                          <v-list-item-icon>
                            <v-icon color="pink"> mdi-trash-can-outline </v-icon>
                          </v-list-item-icon>
                          <v-list-item-title v-text="$t('remove')" />
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </div>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title class="text-wrap">
                    {{ item.name }}({{ item.code }})
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </td>
          </tr>
        </template>
        <template v-slot:item.actions="{ item, index }">
          <div class="pl-action-cell">
            <v-menu offset-y>
            <template v-slot:activator="{ attrs, on }">
              <v-btn color="primary" v-bind="attrs" class="pl-action-cell__btn" icon x-small v-on="on">
                <v-icon small> mdi-dots-vertical </v-icon>
              </v-btn>
            </template>
            <v-list dense>
              <v-list-item link @click="openDialog('edit', item, index)">
                <v-list-item-icon>
                  <v-icon class="mt-2"> mdi-clipboard-edit </v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('edit')" />
              </v-list-item>
              <v-list-item
                v-show="removePermission(typeForm)"
                link
                @click="openDeleteDialog(item)"
              >
                <v-list-item-icon>
                  <v-icon color="pink"> mdi-trash-can-outline </v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('remove')" />
              </v-list-item>
            </v-list>
          </v-menu>
            <span class="pl-action-cell__row">{{ parseInt(items.indexOf(item)) + parseInt(from) }}</span>
          </div>
        </template>
        <template v-slot:item.group="{ item, index }">
          <div class="d-flex align-center gap-1">
            <img
              :src="item.avatar?.link || require('@/assets/imagePlacholder.png')"
              style="width: 35px"
            />
            <v-card-text
              class="pa-0"
              :class="{ 'text-body-2': item.name, 'text-caption': item.name == null }"
              style="color: #0066ff; cursor: pointer"
              @click="openDialog('edit', item, index)"
            >
              {{
                item.name && item.name != null
                  ? item.name
                  : item.group && item.group != null
                  ? item.group
                  : $t("haveNot")
              }}
            </v-card-text>
          </div>
        </template>
        <template v-slot:item.category="{ item, index }">
          <v-card-text class="pa-0 text-body-2">
            {{ item.id != undefined ? resolveCategoryCount(item.id) : "-" }}
          </v-card-text>
        </template>
        <template v-slot:item.subCategory="{ item, index }">
          <v-card-text class="pa-0 text-body-2">
            {{ item.id != undefined ? resolveSubCategoryCount(item.id) : "-" }}
          </v-card-text>
        </template>
        <template v-slot:item.priority="{ item }">
          <v-card-text class="pa-0 text-body-2">
            {{ item.priority ?? item.Priority ?? "-" }}
          </v-card-text>
        </template>
        <template v-slot:item.productCount="{ item }">
          <v-card-text
            class="pa-0"
            :class="{ 'text-body-2': item.id, 'text-caption': item.id == null }"
          >
            {{ item.products_count != undefined ? item.products_count : $t("haveNot") }}
          </v-card-text>
        </template>
        <template v-slot:footer.page-text="{ pageStart, pageStop, itemsLength }">
          {{ faNum(pageStart) }}–{{ faNum(pageStop) }} {{ $t("of") }} {{ faNum($numberFormat(itemsLength)) }}
        </template>
        <template v-slot:footer.prepend>
          <div class="pl-goto">
            <span>{{ $t("goToPage") }}</span>
            <input v-model.number="page" type="number" min="1" :max="pageCount" class="pl-goto__input pl-num" />
            <span class="pl-num">/ {{ faNum(pageCount) }}</span>
          </div>
        </template>
      </v-data-table>
    </pro-list-frame>
    <pro-list-mobile
      v-else
      :title="($t('main-group-list'))"
      :items="items"
      :total="totalItems"
      :loading="loading"
      :page="plPage"
      :page-count="pageCount || 1"
      :search.sync="search"
      :filterable="false"
      :printable="true"
      :card="plAutoCard"
      :actions="plAutoActions"
      :create-label="(!mobileShow) ? $t('new-main-group') : ''"
      @load-more="plLoadPage"
      @refresh="plLoadPage(1)"
      @print="printStudio = true"
      @create="openDialog('add')"
    />
    <print-studio
      v-model="printStudio"
      :report="plReportKey"
      :title="($t('main-group-list'))"
      :columns="plPrintCols"
      :source="plPrintSource"
      @error="serverErrorHandeler"
    />


    <!--delete dialog items of list-->
    <v-dialog
      v-model="deletDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="400"
    >
      <v-card>
        <v-col>
          <v-btn icon class="close-hover" @click="deletDialog = false">
            <v-icon color="grey" large> mdi-close </v-icon>
          </v-btn>
        </v-col>
        <v-col>
          <v-img class="mx-auto" width="200" src="@/assets/stop.svg" />
        </v-col>
        <v-col class="mt-3 pr-7">
          <p class="mx-auto font-weight-medium">
            {{ $t("are-you-sure-delete-this-case") }}
          </p>
        </v-col>
        <v-card-actions>
          <v-row class="ma-0">
            <v-col cols="6">
              <v-btn
                v-if="selected.length > 0"
                color="primary"
                :loading="loading"
                @click="removegroup"
              >
                {{ $t("remove") }}
              </v-btn>
              <v-btn v-if="selected.length == 0" color="primary" @click="removegroup">
                {{ $t("remove") }}
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn
                color="grey"
                outlined
                class="float-left"
                @click="deletDialog = false"
              >
                {{ $t("cancel") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--dialog list (add + edit)-->
    <v-dialog
      v-model="gpDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="450"
    >
      <v-card class="pa-5">
        <v-form ref="form" v-model="valid">
          <div class="d-flex align-center justify-space-between mb-4">
            <v-card-text class="pa-0 text-body-1">
              {{ dialogType == "add" ? $t("new-main-group") : $t("edit-main-group") }}
            </v-card-text>
            <v-icon @click="gpDialog = false" style="cursor: pointer">mdi-close</v-icon>
          </div>
          <div class="group-dialog-body mb-6 mt-6">
            <div class="group-dialog-avatar">
              <file-picker
                ref="refFilePicker"
                v-model="imagePicker"
                :label="$t('uploadImage')"
                :avatar="true"
                :multiple="false"
                extensions="image/png, image/gif, image/jpeg"
                type-prop="categoryAvatar"
                :val="imagePickerVal ? imagePickerVal : null"
              />
            </div>
            <div class="wrapper-toggle-tax d-flex align-center">
              <div
                v-for="(item, statusIndex) in statusOption"
                :key="statusIndex"
                class="child flex-fill text-center"
                :style="{
                  'background-color': status == item.value ? '#0066ff' : '',
                  'border-color': status == item.value ? '#0066ff' : 'silver',
                  color: status == item.value ? '#fff' : '',
                }"
                @click="selectStatusOption(item)"
              >
                <v-card-text class="pa-0 text-body-2">{{ item.label }}</v-card-text>
              </div>
            </div>
            <div class="group-dialog-name-row d-flex align-center gap-2">
              <v-text-field
                v-model="group"
                :label="$t('main-group-title')"
                height="32"
                dense
                outlined
                clearable
                hide-details="auto"
                class="flex-fill mt-0 pt-0"
                :rules="[(v) => !!v || $t('is-required')]"
              />
              <v-text-field
                v-model.number="priority"
                :label="$t('priority')"
                type="number"
                height="32"
                dense
                outlined
                clearable
                hide-details
                class="group-dialog-priority mt-0 pt-0"
              />
            </div>
          </div>

          <div class="d-flex justify-end gap-2">
            <v-btn
              color="error"
              outlined
              :loading="loading"
              height="32"
              @click="gpDialog = false"
            >
              {{ $t("cancel") }}
            </v-btn>
            <v-btn
              color="primary"
              :loading="loading"
              height="32"
              @click="checkValidation"
              :disabled="!itemHasId"
            >
              {{ dialogType == "add" ? $t("confirm") : $t("edit") }}
            </v-btn>
          </div>
        </v-form>
      </v-card>
    </v-dialog>
    <v-snackbar
      v-model="snakbar"
      :color="snakbarColor ? snakbarColor : 'primary'"
      top
      style="z-index: 1000000000000 !important"
    >
      {{ snakbarText }}

      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snakbar = !snakbar">
          {{ $t("close") }}
        </v-btn>
      </template>
    </v-snackbar>
    <Confirm ref="confirm" />
  </div>
</template>

<script>
import { required } from "vee-validate/dist/rules";
import General from "../../../../Mixins/general";
import filePicker from "../../components/general/filePicker/index";
import {
  applyColumnSettings,
  loadColumnSettings,
} from "@/plugins/columnSettings/columnSettings";
import { reorderPinnedHeaders } from "@/plugins/columnPin/columnPin";

import ProList from "@/Mixins/proList";

import ProListFrame from "@/components/proList/ProListFrame.vue";

import ProListMobile from "@/components/proList/ProListMobile.vue";

import PrintStudio from "@/modules/print/PrintStudio.vue";

export default {
  name: "category",
  components: {
    ProListFrame,
    ProListMobile,
    PrintStudio,
    autocomplete: () => import("../../components/general/patial/autocomplete"),
    aicomplete: () => import("../../components/general/AIcomplete/index"),
    filePicker,
  },
  mixins: [General, ProList],
  props: ["input", "type", "refId", "mobileShow", "titleProp"],
  data: () => ({
    selected: [],
    pageCount: 1,
    page: 1,
    selectedHeaders: [],
    deletDialog: false,
    showSelect: true,
    model: null,
    from: 1,
    temp: null,
    deleteItem: null,
    items: [],
    subCategoryList: [],
    categoryList: [],
    sortBy: [],
    dialog: null,
    timer: 0,
    totalItems: 0,
    snakbar: false,
    typeForm: null,
    snakbarText: null,
    loading: true,
    options: {
      itemsPerPage: 5,
    },
    headers: null,
    listViewportObserver: null,
    listViewportRaf: null,
    search: null,
    gpDialog: false,
    dialogType: null,
    valid: true,
    editedIndex: null,
    editedItem: null,
    newItem: {},
    group: null,
    itemHasId: true,
    attachedImg: null,
    selectedImageFile: null,
    imagePicker: null,
    imagePickerVal: null,
    status: "active",
    priority: null,
  }),
  computed: {

    proListKey () {

      return this.mainGroupColumnPersistKey

    },

    proListLocked () {

      return this.mainGroupLockedColumns

    },
    isMobile() {
      return this.$vuetify.breakpoint.name === "xs";
    },
    isDesktopListViewport() {
      return !this.isMobile && !this.mobileShow;
    },
    mainGroupColumnPersistKey() {
      return "group-main-list-columns-" + (this.$route.name || "mainGroup");
    },
    mainGroupLockedColumns() {
      // Fixed sticky block: select + actions + row (no id column in this list)
      var locked = ["actions"];
      return this.showSelect ? ["__select"].concat(locked) : locked;
    },
    mainGroupColumnPlugins() {
      // show-select inserts a leading checkbox <th>; pad visibleHeaders so
      // pin/resize/drag index mapping stays aligned with thead cells.
      var selectHeader = {
        value: "__select",
        text: "",
        width: 32,
        sortable: false,
        pinned: false,
        originalIndex: -1,
      };
      var visible = this.showSelect
        ? [selectHeader].concat(this.tableHeaders || [])
        : this.tableHeaders || [];
      return {
        headers: this.headers,
        visibleHeaders: visible,
        locked: this.mainGroupLockedColumns,
        anchor: "group",
        minWidth: 60,
        persistKey: this.mainGroupColumnPersistKey,
      };
    },
    showHeaders() {
      var app = this;
      return this.headers.filter(function (s) {
        return app.selectedHeaders.includes(s);
      });
    },
    statusOption() {
      return [
        { label: this.$t("active"), value: "active" },
        { label: this.$t("deactive"), value: "deactive" },
      ];
    },
  },
  watch: {
    refId(val, oldVal) {
      // this.items = []
      this.getItems();
    },
    model() {
      this.$emit("input", this.model);
    },
    selected() {
      this.$emit("input", this.selected.text);
      if (this.selected.length > 0) {
        this.model = this.selected[0].text;
        this.temp = this.selected[0].text;
      }
      this.dialog = false;
    },
    search() {
      var app = this;
      app.loading = true;
      app.page = 1;
      clearTimeout(this.timer);
      this.timer = setTimeout(function () {
        app.getItems();
      }, 1000);
    },
    options: {
      handler() {
        var app = this;
        app.sortBy = [];
        app.options.sortBy.map(function (value, key) {
          const index = app.headers.findIndex((h) => h.value === value);
          app.sortBy.push(app.headers[index].table);
        });
        this.getItems();
      },
      deep: true,
      immediate: false,
    },
    sortBy() {
      const index = this.headers.findIndex((h) => h.value === this.sortBy);
      if (index > -1) {
        this.sortBy = this.headers[index].table;
      }
    },
    loading(val) {
      if (!val && this.isDesktopListViewport) {
        this.$nextTick(() => {
          this.bindListViewportObserver();
          this.scheduleDesktopTableHeightUpdate();
        });
      }
    },
    isDesktopListViewport(val) {
      if (val) {
        this.$nextTick(() => {
          this.updateDesktopTableHeight();
          this.bindListViewportObserver();
        });
      } else {
        this.unbindListViewportObserver();
        this.tableHeight = window.innerHeight - 245;
      }
    },
  },
  beforeMount() {
    if (this.$route.name === "mainGroup") {
      this.typeForm = "group";
    }
    this.headers = [
      {
        text: this.$t("#"),
        align: "center",
        sortable: false,
        value: "actions",
        width: 42,
        class: "pl-action-col",
        cellClass: "pl-action-col",
      },
      {
        text: this.$t("main-group-title"),
        sortable: false,
        value: "group",
      },
      {
        text: this.$t("priority"),
        sortable: false,
        value: "priority",
      },
      {
        text: this.$t("sub-group-count"),
        sortable: false,
        value: "category",
      },
      {
        text: this.$t("sub-category-count"),
        sortable: false,
        value: "subCategory",
      },
      {
        text: this.$t("countProductInvoice"),
        sortable: false,
        value: "productCount",
      },
    ];
    if (this.input) {
      this.model = this.input;
    }
    this.headersMap = this.headers;
    this.selectedHeaders = this.headers;
    reorderPinnedHeaders(this.headers, {
      locked: this.mainGroupLockedColumns,
      anchor: "group",
    });
    this.loadMainGroupColumnSettings();
  },
  methods: {
    resolveRefEl(ref) {
      if (!ref) return null;
      return ref.$el || ref;
    },
    onResize() {
      if (this.isDesktopListViewport) {
        this.updateDesktopTableHeight();
        return;
      }
      this.tableHeight = window.innerHeight - 245;
    },
    scheduleDesktopTableHeightUpdate() {
      if (this.listViewportRaf) cancelAnimationFrame(this.listViewportRaf);
      this.listViewportRaf = requestAnimationFrame(() => {
        this.listViewportRaf = null;
        this.updateDesktopTableHeight();
      });
    },
    updateDesktopTableHeight() {
      if (!this.isDesktopListViewport) {
        this.tableHeight = window.innerHeight - 245;
        return;
      }
      const rootEl = this.resolveRefEl(this.$refs.listRoot);
      const toolbarEl = this.resolveRefEl(this.$refs.listToolbar);
      const summaryEl = this.resolveRefEl(this.$refs.listSummary);
      const tableColEl = this.resolveRefEl(this.$refs.listTableCol);
      const tableEl = this.resolveRefEl(this.$refs.listTable);
      if (!rootEl || !tableColEl) {
        this.tableHeight = window.innerHeight - 245;
        return;
      }
      const rootStyle = window.getComputedStyle(rootEl);
      const rootPadding =
        (parseFloat(rootStyle.paddingTop) || 0) +
        (parseFloat(rootStyle.paddingBottom) || 0);
      const toolbarHeight = toolbarEl ? toolbarEl.offsetHeight : 0;
      let summaryHeight = 0;
      if (summaryEl) {
        const summaryVisible =
          summaryEl.offsetParent !== null ||
          summaryEl.getClientRects().length > 0;
        if (summaryVisible) {
          const summaryStyle = window.getComputedStyle(summaryEl);
          summaryHeight =
            summaryEl.offsetHeight +
            (parseFloat(summaryStyle.marginTop) || 0) +
            (parseFloat(summaryStyle.marginBottom) || 0);
        }
      }
      const colStyle = window.getComputedStyle(tableColEl);
      const colPadding =
        (parseFloat(colStyle.paddingTop) || 0) +
        (parseFloat(colStyle.paddingBottom) || 0);
      const footerEl = tableEl
        ? tableEl.querySelector(".v-data-footer")
        : null;
      const footerHeight = footerEl ? footerEl.offsetHeight : 0;
      const tableStyle = tableEl ? window.getComputedStyle(tableEl) : null;
      const tableMargins = tableStyle
        ? (parseFloat(tableStyle.marginTop) || 0) +
          (parseFloat(tableStyle.marginBottom) || 0)
        : 0;
      const available =
        rootEl.clientHeight -
        rootPadding -
        toolbarHeight -
        summaryHeight -
        colPadding -
        footerHeight -
        tableMargins -
        3;
      this.tableHeight = Math.max(180, Math.floor(available));
    },
    bindListViewportObserver() {
      if (typeof ResizeObserver === "undefined") return;
      this.unbindListViewportObserver();
      const rootEl = this.resolveRefEl(this.$refs.listRoot);
      const summaryEl = this.resolveRefEl(this.$refs.listSummary);
      const tableColEl = this.resolveRefEl(this.$refs.listTableCol);
      const tableEl = this.resolveRefEl(this.$refs.listTable);
      const footerEl = tableEl ? tableEl.querySelector(".v-data-footer") : null;
      if (!rootEl && !summaryEl && !tableColEl) return;
      this.listViewportObserver = new ResizeObserver(() => {
        this.scheduleDesktopTableHeightUpdate();
      });
      if (rootEl) this.listViewportObserver.observe(rootEl);
      if (summaryEl) this.listViewportObserver.observe(summaryEl);
      if (tableColEl) this.listViewportObserver.observe(tableColEl);
      if (footerEl) this.listViewportObserver.observe(footerEl);
    },
    unbindListViewportObserver() {
      if (this.listViewportObserver) {
        this.listViewportObserver.disconnect();
        this.listViewportObserver = null;
      }
    },
    loadMainGroupColumnSettings() {
      var app = this;
      if (!app.headers || !app.headers.length) return;
      loadColumnSettings(app, app.mainGroupColumnPersistKey).then(function (snapshot) {
        if (!snapshot || !snapshot.length) return;
        applyColumnSettings(app.headers, snapshot, {
          locked: app.mainGroupLockedColumns,
          anchor: "group",
        });
        app.$forceUpdate();
      });
    },
    ImgSelected(e) {
      const file = e.target.files[0];
      if (!file) return;

      this.selectedImageFile = file;
      this.attachedImg = URL.createObjectURL(file);
    },
    getItems() {
      var app = this;
      app.loading = true;
      app.$axios
        .get(this.$endpoint + "productcategory", {
          params: {
            type: "group",
            page: app.options.page,
            itemPerPage: 10,
            parents: null,
            filter: null,
            search: this.search,
          },
        })
        .then((res) => {
          res = res.data;
          app.items = res.data;
          app.totalItems = res.total;
          app.pageCount = res.last_page;
          app.from = res.from;
        })
        .catch((err) => {
          this.serverErrorHandeler(err);
        })
        .finally(() => (app.loading = false));
    },
    getCategoryList() {
      var app = this;
      app.loading = true;
      app.$axios
        .get(this.$endpoint + "productcategory", {
          params: {
            type: "category",
            page: 1,
            itemPerPage: 10000,
            parents: null,
            filter: null,
            search: null,
          },
        })
        .then((res) => {
          res = res.data;
          app.categoryList = res.data;
        });
    },
    getSubCategoryList() {
      var app = this;
      app.loading = true;
      app.$axios
        .get(this.$endpoint + "productcategory", {
          params: {
            type: "subCategory",
            page: 1,
            itemPerPage: 10000,
            parents: null,
            filter: null,
            search: null,
          },
        })
        .then((res) => {
          res = res.data;
          app.subCategoryList = res.data;
        });
    },
    resolveCategoryCount(groupId) {
      if (this.categoryList.length > 0) {
        const category = this.categoryList.filter((item) => item.parent_id == groupId);
        return category.length;
      }
    },
    resolveSubCategoryCount(groupId) {
      if (this.categoryList.length > 0) {
        const category = this.categoryList.filter((item) => item.parent_id == groupId);
        if (category != undefined && category.length != 0) {
          const categoryId = category.map((item) => item.id);
          for (var i = 0; i < categoryId.length; ) {
            const subCategory = this.subCategoryList.filter(
              (item) => item.parent_id == categoryId[i]
            );
            subCategory.length++;
            return subCategory.length - 1;
          }
        } else {
          return 0;
        }
      }
    },
    openDialog(type, item, index) {
      this.dialogType = type;
      this.gpDialog = true;
      if (this.dialogType == "add") {
        this.itemHasId = true;
        this.clearModal();
      }
      if (this.dialogType == "edit" && item != undefined && index != undefined) {
        if (item.id != undefined) {
          this.group = item.name;
          this.imagePicker = item.avatar;
          this.imagePickerVal = item.avatar;
          this.status = item.status || "active";
          this.priority = item.priority ?? item.priority ?? null;
          this.itemHasId = true;
        } else {
          this.group = item.group;
          this.status = item.status || "active";
          this.priority = item.priority ?? item.priority ?? null;
          this.itemHasId = false;
        }
        this.editedIndex = index;
        this.editedItem = item;
      }
    },
    clearModal() {
      this.group = null;
      this.imagePicker = null;
      this.imagePickerVal = null;

      if (this.$refs.form) {
        this.$refs.form.reset();
      }

      this.status = "active";
      this.priority = null;
    },
    selectStatusOption(item) {
      this.status = item.value;
    },
    checkValidation() {
      if (this.dialogType == "add" && this.$refs.form.validate()) {
        this.add();
      }
      if (this.dialogType == "edit" && this.$refs.form.validate()) {
        this.edit();
      }
    },
    add() {
      this.newItem.group = this.group;
      this.newItem.image = this.imagePicker;
      this.newItem.status = this.status;
      this.newItem.priority = this.priority;

      var app = this;
      app.loading = true;

      app.$axios
        .post(app.$endpoint + "productcategory", {
          name: app.newItem.group,
          type: "group",
          parent: 0,
          image: app.newItem.image,
          status: app.status,
          priority: app.priority,
        })
        .then((res) => {
          res = res.data;
          const saved = res.data || {};
          if (app.newItem.image) {
            app.$refs.refFilePicker.create(saved.id);
          }
          app.items.push({
            ...saved,
            name: saved.name || app.newItem.group,
            status: saved.status || app.status,
            priority: saved.priority ?? app.priority,
          });
          app.gpDialog = false;
          app.$refs.refFilePicker.remove(null, 0);
        })
        .catch((err) => {
          app.serverErrorHandeler(err);
        })
        .finally(() => {
          app.loading = false;
        });
    },
    edit() {
      this.newItem.group = this.group;
      this.newItem.image = this.imagePicker;
      this.newItem.status = this.status;
      this.newItem.priority = this.priority;

      var app = this;
      app.loading = true;
      var id = app.editedItem.id;
      app.$axios
        .put(`${app.$endpoint}productcategory/${id}`, {
          name: app.newItem.group,
          type: "group",
          parent: 0,
          image: app.newItem.image,
          status: app.status,
          priority: app.priority,
        })
        .then((res) => {
          res = res.data;
          const saved = res.data || {};
          if (app.newItem.image) {
            app.$refs.refFilePicker.create(saved.id);
          }
          app.items.splice(app.editedIndex, 1, {
            ...app.editedItem,
            ...saved,
            name: saved.name || app.newItem.group,
            status: saved.status || app.status,
            priority: saved.priority ?? app.priority,
          });
          app.gpDialog = false;
          app.$refs.refFilePicker.remove(null, 0);
        })
        .catch((err) => {
          app.serverErrorHandeler(err);
        })
        .finally(() => (app.loading = false));
    },
    openDeleteDialog(item) {
      this.deleteItem = item;
      this.deletDialog = true;
    },
    removegroup() {
      var app = this;
      app.loading = true;

      if (this.selected.length > 0) {
        var selected = [];
        this.selected.map(function (value) {
          selected.push(value.id);
        });

        const ids = selected.join(",");

        app.$axios
          .delete(`${this.$endpoint}productcategory/${ids}`)
          .then((res) => {
            this.getItems();
            app.deletDialog = false;
            app.deleteItem = null;
            app.selected = [];
          })
          .catch((err) => {
            this.deletDialog = false;
            this.serverErrorHandeler(err);
          })
          .finally(function () {
            app.deleteItem = null;
            app.selected = [];
            app.loading = false;
          });
      } else {
        app.$axios
          .delete(this.$endpoint + "productcategory/" + this.deleteItem.id)
          .then((res) => {
            this.getItems();
            app.deletDialog = false;
            app.deleteItem = null;
            app.selected = [];
          })
          .catch((err) => {
            this.deletDialog = false;
            this.serverErrorHandeler(err);
          })
          .finally(function () {
            app.deleteItem = null;
            app.selected = [];
            app.loading = false;
          });
      }
    },
  },
  mounted() {
    this.getCategoryList();
    this.getSubCategoryList();
    if (this.isDesktopListViewport) {
      this.$nextTick(() => {
        this.bindListViewportObserver();
        this.updateDesktopTableHeight();
        this.$nextTick(() => {
          this.bindListViewportObserver();
          this.scheduleDesktopTableHeightUpdate();
        });
      });
    }
  },
  activated() {
    if (this.isDesktopListViewport) {
      this.$nextTick(() => {
        this.bindListViewportObserver();
        this.scheduleDesktopTableHeightUpdate();
      });
    }
  },
  deactivated() {
    this.unbindListViewportObserver();
  },
  beforeDestroy() {
    this.unbindListViewportObserver();
    if (this.listViewportRaf) {
      cancelAnimationFrame(this.listViewportRaf);
      this.listViewportRaf = null;
    }
  },
};
</script>

<style scoped lang="scss">
@import "~@/sass/design-system/list/pro-list";

::v-deep .ma-0.mt-0.pt-0.v-card.v-card--flat.v-sheet.theme--light {
  width: auto !important;
}
::v-deep .v-avatar.rounded {
  width: 80px !important;
  min-width: 80px !important;
  max-width: 80px !important;
}
::v-deep
  .v-text-field--outlined.v-input--dense.v-text-field--outlined
  > .v-input__control
  > .v-input__slot {
  min-height: 32px !important;
}
::v-deep .v-input--selection-controls__input {
  margin-left: 0;
  width: auto;
}
::v-deep .v-input--selection-controls__ripple {
  width: auto;
  height: auto;
  margin: 0;
}
::v-deep .v-btn--icon.v-size--default {
  height: auto;
  width: auto;
}
::v-deep .v-data-table table thead tr th,
::v-deep .v-data-table table tbody tr td {
  white-space: nowrap;
}
::v-deep
  .theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:nth-child(odd),
::v-deep
  .theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:nth-child(even) {
  /* background-color: transparent !important; */
  height: 60px;
}
.v-card__text {
  width: auto;
}
.wrapper-toggle-tax {
  border: 1px solid #d0d0d0;
  border-radius: 4px;
  width: 100%;
  height: 32px;
  overflow: hidden;
}
.wrapper-toggle-tax .child {
  padding: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.wrapper-toggle-tax .child:first-child {
  border-left: 1px solid #d0d0d0;
}
.wrapper-toggle-tax .v-card__text {
  width: 100%;
}
.group-dialog-body {
  display: grid;
  grid-template-columns: 96px 1fr;
  grid-template-rows: 32px 1fr;
  gap: 12px;
  align-items: start;
}
.group-dialog-avatar {
  grid-column: 1;
  grid-row: 1 / 3;
  width: 96px;
  height: 96px;
  max-width: 96px;
  overflow: visible;
}
.group-dialog-avatar ::v-deep .v-card {
  width: 96px !important;
  max-width: 96px !important;
  height: 96px !important;
}
.group-dialog-avatar ::v-deep .v-avatar,
.group-dialog-avatar ::v-deep .v-image,
.group-dialog-avatar ::v-deep img {
  width: 96px !important;
  min-width: 96px !important;
  max-width: 96px !important;
  height: 96px !important;
  max-height: 96px !important;
  aspect-ratio: 1 / 1 !important;
}
.group-dialog-avatar ::v-deep .v-btn {
  top: 0 !important;
}
.group-dialog-body .wrapper-toggle-tax {
  grid-column: 2;
  grid-row: 1;
}
.group-dialog-name-row {
  grid-column: 2;
  grid-row: 2;
  min-width: 0;
  align-self: center;
  margin-top: 8px;
}
.group-dialog-priority {
  flex: 0 0 88px;
  max-width: 88px;
}
.v-data-table >>> .v-data-table__wrapper::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.v-data-table >>> .v-data-table__wrapper::-webkit-scrollbar-thumb {
  background-color: silver;
}

.v-data-table >>> .v-data-table__wrapper::-webkit-scrollbar-track {
  background-color: #f1f1f1;
}
@media (max-width: 863px) {
  ::v-deep .v-data-table table tbody tr,
  ::v-deep
    .theme--light.v-data-table
    > .v-data-table__wrapper
    > table
    > tbody
    > tr:nth-child(odd),
  ::v-deep
    .theme--light.v-data-table
    > .v-data-table__wrapper
    > table
    > tbody
    > tr:nth-child(even) {
    height: auto;
  }
}
</style>
